import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLeadModal } from "./LeadModalContext";
import { useContent } from "../../context/ContentContext";

export default function FinalCTA() {
  const { open: openLead } = useLeadModal();
  const { t } = useContent();
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="relative py-28 sm:py-40 overflow-hidden"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[140%] bg-[radial-gradient(ellipse_50%_60%_at_50%_50%,_rgba(0,85,255,0.35),_transparent_70%)]" />
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[60%] bg-[radial-gradient(ellipse_30%_50%_at_50%_50%,_rgba(0,229,255,0.2),_transparent_80%)]" />
      </div>
      <div className="absolute inset-0 subtle-grid opacity-60" />
      <div className="relative max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          data-testid="final-cta-headline"
          className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tighter chrome-text leading-[1.05]"
        >
          {t("homepage.final.headline_part1", "Enter the next era")}
          <br />
          {t("homepage.final.headline_part2", "of payments.")}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 text-zinc-400 text-[15px] sm:text-[17px] max-w-xl mx-auto leading-relaxed"
        >
          {t("homepage.final.body", "Talk to our team about migrating, scaling or launching new payment experiences with Neptune.")}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-9 flex items-center justify-center gap-3 flex-wrap"
        >
          <Link
            to="/signup"
            data-testid="final-cta-get-started-btn"
            className="group inline-flex items-center justify-center gap-1.5 rounded-full bg-white text-black hover:bg-zinc-200 transition-all px-6 py-3.5 text-[14px] font-medium"
          >
            Get Started
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </Link>
          <button
            type="button"
            onClick={() => openLead("contact")}
            data-testid="final-cta-contact-btn"
            className="group inline-flex items-center justify-center gap-1.5 rounded-full border border-white/[0.12] bg-white/[0.02] text-white hover:bg-white/[0.06] hover:border-white/[0.22] transition-colors px-6 py-3.5 text-[14px] font-medium"
          >
            {t("homepage.final.cta_label", "Contact Neptune")}
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
